import React, { useEffect, useState } from "react";
import { getProject } from "../api/client";
import { useParams, Link } from "react-router-dom";
import { getImageUrl } from "../utils/imageUtils";


const ProjectDetail = ({ settings, lang }) => {
    const { slug } = useParams();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getProject(slug);
                setProject(response.data);
            } catch (error) {
                console.error("Failed to fetch project details:", error);
            } finally {
                setLoading(false);
            }
        };
        if (slug) fetchData();
    }, [slug]);

    const getText = (en, ar) => (lang === "en" ? en : ar);
    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader
    if (!loading && !project) return <div className="text-center py-5">Project not found.</div>;

    return (
        <section className="py-5">
            <div className="container py-5">
                <div id="project-content" className="row justify-content-center">
                    {loading ? (
                        <div className="col-12 py-5 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-10">
                            <img src={getImageUrl(project.image, 'imgPro')} className="w-100 rounded-custom shadow-lg mb-5 object-fit-cover" style={{ height: '400px' }} alt="Project" />
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="mb-3 badge bg-primary text-dark">
                                        {lang === 'en' ? project.sector_en : project.sector_ar}
                                    </div>
                                    <h1 className="fw-bold mb-4">{lang === 'en' ? project.title_en : project.title_ar}</h1>
                                    <h4 className="fw-bold mb-3">{getText("Overview", "نظرة عامة")}</h4>
                                    <p className="lead text-muted mb-5">{lang === 'en' ? project.overview_en : project.overview_ar}</p>
                                    <h4 className="fw-bold mb-3">{getText("Idea and execution", "الفكرة و التنفيذ")}</h4>
                                    <p>{lang === 'en' ? project.description_en : project.description_ar}</p>
                                </div>
                                <div className="col-lg-4">
                                    <div className="card-custom bg-card">
                                        <h5 className="fw-bold mb-3">{getText("Project Info", "معلومات المشروع")}</h5>
                                        <ul className="list-unstyled">
                                            {project.customer && (
                                                <li className="mb-2"><strong>{getText("Client:", "العميل:")}</strong> {project.customer}</li>
                                            )}
                                            {project.year && (
                                                <li className="mb-2"><strong>{getText("Date:", "التاريخ:")}</strong> {project.year}</li>
                                            )}
                                            <li className="mb-2"><strong>{getText("Category:", "الفئة:")}</strong> {lang === 'en' ? project.sector_en : project.sector_ar}</li>
                                        </ul>
                                        <Link to="/contact" className="btn btn-primary-custom w-100 mt-3">
                                            {getText("Start a Project Like This", "ابدأ مشروعًا كهذا")}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ProjectDetail;
